import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-save-description-dialog',
  templateUrl: './save-description-dialog.component.html',
  styleUrls: ['./save-description-dialog.component.scss']
})
export class SaveDescriptionDialogComponent implements OnInit {

  description: String;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<SaveDescriptionDialogComponent>) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(null);
  }

  send() {
    this.dialogRef.close(this.description.trim());
  }

  validateDescription() {
    let validation = false;
    if (!this.description) {
      validation = true;
    } else {
      if (this.description.trim().length === 0) {
        validation = true;
      }
    }
    return validation;
  }



}
